import React from 'react';
import PropTypes from 'prop-types';
import { PropTypeBn } from '@blockcatio/tabby-library/lib/utilities/PropTypeBn';
import { noop } from 'lodash';

import WalletInfo from '../../components/WalletInfo';
import CampaignList from '../../components/CampaignList';
import PropTypeCampaign from '../../utilities/propTypes/PropTypeCampaign';

const ManageCampaigns = ({
  campaigns,
  isLoading,
  onDiscardCampaign,
  address,
  balance,
  catBalance,
  onWalletChange,
}) => (
  <div className="manage-campaigns">
    <h1>Manage Campaigns</h1>
    {!isLoading && (
      <WalletInfo
        address={address}
        balance={balance}
        catBalance={catBalance}
        onWalletChange={onWalletChange}
        showChangeWallet
      />
    )}

    <div className="content">
      <CampaignList
        campaigns={campaigns}
        isLoading={isLoading}
        onDiscardCampaign={onDiscardCampaign}
      />
    </div>
  </div>
);

ManageCampaigns.defaultProps = {
  campaigns: [],
  isLoading: false,
  onDiscardCampaign: noop,
  address: '',
  balance: null,
  catBalance: null,
  onWalletChange: noop,
};

ManageCampaigns.propTypes = {
  campaigns: PropTypes.arrayOf(PropTypes.shape(PropTypeCampaign)),
  isLoading: PropTypes.bool,
  onDiscardCampaign: PropTypes.func,
  address: PropTypes.string,
  balance: PropTypeBn,
  catBalance: PropTypeBn,
  onWalletChange: PropTypes.func,
};

export default ManageCampaigns;



// WEBPACK FOOTER //
// ./src/containers/campaigns/ManageCampaigns.js